import { render, staticRenderFns } from "./DetalhesVoucher.vue?vue&type=template&id=738ee3a3&"
import script from "./DetalhesVoucher.vue?vue&type=script&lang=js&"
export * from "./DetalhesVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports